exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".page_lost_com[data-v-4a317d03]{text-align:center;line-height:100px;color:#ff00ff;padding:30px}.lost-tip[data-v-4a317d03]{color:#ff00ff;position:fixed;z-index:1000;left:0;top:0;right:0;bottom:0;background-color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}\n", ""]);

// exports
